import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { RequestProButton } from './RequestProButton';

const TYPE_TO_SPECIALTY = {
  financial_advisor: 'financial_planner',
  cpa_tax: 'financial_planner',
  estate_attorney: 'estate_planner',
  family_therapist: 'family_counselor',
  real_estate: 'other',
  insurance: 'other',
};

export const ComingSoonAdvisors = ({ typeKey = '', typeLabel = '', location = '', testId = 'coming-soon-advisors' }) => {
  const who = typeLabel ? `${typeLabel}s` : 'trusted advisors';
  const where = location ? ` in ${location}` : ' in your area';

  return (
    <div className="max-w-xl mx-auto text-center py-12 px-6 bg-white rounded-2xl border border-emerald-100 shadow-sm" data-testid={testId}>
      <div className="w-16 h-16 rounded-full bg-emerald-50 flex items-center justify-center mx-auto mb-5">
        <Sparkles className="text-emerald-600" size={28} />
      </div>
      <h3 className="text-xl font-bold text-gray-800 mb-2" data-testid={`${testId}-title`}>Coming soon{where}</h3>
      <p className="text-gray-600 mb-6">
        We're adding {who}{where} right now. Tell us what you need and we'll notify you the moment a match joins.
      </p>
      <RequestProButton
        label="Notify me when one joins"
        testId={`${testId}-notify-btn`}
        initialSpecialty={TYPE_TO_SPECIALTY[typeKey] || ''}
        initialCity={location}
      />
      <p className="text-sm text-gray-500 mt-5">
        Know a great advisor?{' '}
        <Link to="/my-invitations" className="text-emerald-700 font-medium hover:underline" data-testid={`${testId}-invite-link`}>
          Invite them to join
        </Link>
      </p>
    </div>
  );
};
